import { createApi } from "../../utils/createApi";

/**
 * GET /api/vpn-status/ (actuate_admin, ENG-2531). Read-only: every WireGuard
 * tunnel and IPsec (site-to-site) VPN of the user's groups, scoped server-side
 * — the server never returns another customer's VPNs or routes.
 */
export type VpnKind = "wireguard" | "ipsec";
export type VpnState = "up" | "down" | "unknown";

export interface VpnSite {
  id: number;
  name: string;
}

export interface VpnStatusRow {
  /** "wireguard-12" / "ipsec-5": unique across both kinds. */
  id: string;
  kind: VpnKind;
  object_id: number;
  name: string;
  group: { id: number; name: string } | null;
  /** IPsec: "up" while at least one of its tunnels is up. */
  status: VpnState;
  tunnels_up: number | null;
  tunnels_total: number | null;
  /** WireGuard only. */
  last_handshake: string | null;
  /** IPsec only: the latest tunnel status change. */
  last_change: string | null;
  routes: string[];
  /** WireGuard only: the client's tunnel address. */
  tunnel_ip: string | null;
  /** The customer translates these ranges on their side (WireGuard). */
  routes_virtual: boolean;
  /** null = the routes could not be read, so riding sites are unknown. */
  sites: VpnSite[] | null;
  camera_count: number | null;
}

export interface VpnStatusResponse {
  vpns: VpnStatusRow[];
  checked_at: string;
}

export const fetchVpnStatus = async (): Promise<VpnStatusResponse> => {
  const { data } = await createApi("").get<VpnStatusResponse>("vpn-status/");
  return {
    vpns: Array.isArray(data?.vpns) ? data.vpns : [],
    checked_at: data?.checked_at ?? new Date().toISOString(),
  };
};
